import { render } from "./JobListings.vue?vue&type=template&id=70bad5b4"
import script from "./JobListings.vue?vue&type=script&lang=js"
export * from "./JobListings.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__